<template>
  <div ref="staffOverlayRef"
       :style="{maxHeight: '400px'}">
    <p class="gray-darker fw-500 font-16">全部员工（{{staff.total || 0}}）</p>
    <a-Divider class="mv8" />
    <a-input class="mb2"
             v-model:value="searchForm.staffName"
             placeholder="请输入员工名称"
             style="width: 200px"
             @change="listLoading = true; onSearch()"
             @click.stop />
    <a-spin :spinning="listLoading">
      <ul class="overflow-y-auto"
          style="height: 220px;"
          ref="listRef"
          @scroll="load">
        <li class="mb2 staff-item hover:bg-admin-primary hover:bg-opacity-10"
            v-for="staff in staff.list"
            :key="staff.id"
            @click="chooseStaff(staff)">
          <avatar-column width="120px"
                         is-user-id
                         :avatar="{
              avatar: staff.avatar,
              userId: staff.workWechatThirdAppUserId
            }" />
        </li>
      </ul>
    </a-spin>

  </div>
</template>

<script>
import _ from "lodash";
import { defineComponent, ref, reactive, onMounted } from "vue";
import { apiBus } from "@/shared/service/api-client";
import { Divider } from "ant-design-vue";

import AvatarColumn from "@/components/AvatarColumn";

import staffApi from "@/service/api/staff";

export default defineComponent({
  name: "SelectStaff",

  components: {
    AvatarColumn,
    ADivider: Divider,
  },

  setup(props, { emit }) {
    const searchForm = reactive({
      staffName: "",
      page: 0,
    });

    const staff = reactive({
      list: [],
      total: "",
    });
    const listRef = ref();

    const listLoading = ref(false);

    async function onLoad() {
      const res = await staffApi.search(searchForm);

      for (let i = 0, length = res.data.length; i < length; i++) {
        staff.list.push(res.data[i]);
      }

      listLoading.value = false;
    }
    function load() {
      var scrollHeight = listRef.value.scrollHeight;
      var scrollTop = listRef.value.scrollTop;
      var clientHeight = listRef.value.clientHeight;

      if (scrollHeight - clientHeight == scrollTop) {
        searchForm.page++;
        onLoad();
      }
    }
    const onSearch = _.debounce(() => {
      searchForm.page = 0;
      staff.list = [];
      onLoad();
    }, 500);

    function chooseStaff(staff) {
      emit("choose", staff);
    }

    const staffOverlayRef = ref();

    onMounted(async () => {
      apiBus.on("closeAssignModal", () => {
        searchForm.staffName = "";
        onSearch();
      });

      const res = await staffApi.search();
      staff.total = res.total;

      onLoad();
    });

    return {
      searchForm,
      staff,

      chooseStaff,

      staffOverlayRef,
      listRef,
      listLoading,

      load,
      onSearch,
    };
  },
});
</script>
<style lang='less' scoped>
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
</style>